"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformBillingAddress = exports.transformMop = void 0;
var transformMop = function (mop) {
    if (mop.billing) {
        var transformedBillingAddress = (0, exports.transformBillingAddress)(mop.billing);
        mop.billing = transformedBillingAddress;
    }
    return mop;
};
exports.transformMop = transformMop;
var transformBillingAddress = function (billingAddress) {
    var fname = billingAddress.fname, lname = billingAddress.lname, zip = billingAddress.zip, city = billingAddress.city, state = billingAddress.state, line1 = billingAddress.line1, line2 = billingAddress.line2, country = billingAddress.country, phone = billingAddress.phone;
    return {
        fname: fname !== null && fname !== void 0 ? fname : '',
        lname: lname !== null && lname !== void 0 ? lname : '',
        city: city !== null && city !== void 0 ? city : '',
        state: state !== null && state !== void 0 ? state : '',
        line1: line1 !== null && line1 !== void 0 ? line1 : '',
        line2: line2,
        zip: zip || 'abcde',
        phone: phone,
        country: country.toUpperCase(),
    };
};
exports.transformBillingAddress = transformBillingAddress;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/checkout-sdk/dist/lib-esm/modules/common/transforms/transformMop.js
// module id = 3393
// module chunks = 11